<template>
  <div :class="['position-relative', isTopBottomBar ? 'inline-element' : 'w-100']">
    <slot name="dropzone"></slot>
    <div class="w-100"/>
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        :can-have-template="true"
        :has-template="!!config.templateId"
        @removeBlock="$emit('removeBlock')"
        @editProperty="editProperty"
        @editTemplate="editTemplate"
    />

    <div :class="['step-nav-wrapper', isTopBottomBar ? 'step-nav-bar-padding step-nav-row' : '']">
      <div
          v-for="step in sortedSteps"
          :key="step.uuid"
          :class="[
            'vform-slide-control-element',
            isTopBottomBar ? 'inline-button no-margin-bottom' : (config.alignment || 'left'),
            !editorMode && !disabled && !state.dragging ? 'button-hover-effect' : 'no-button-hover-effect',
          ]"
      >
        <div
            :class="[
              'vform-button-no-tiles', 'simple-button', 'border-radius',
              !editorMode && !disabled && !state.dragging ? 'clickable' : 'no-button-hover-effect',
              config.alignment || 'left',
            ]"
            :style="getButtonStyle(step.uuid)"
            @click="navigate(step.uuid)"
        >
          <div class="non-preview d-flex">
            <div class="text wrap-break without-icon">
              {{ step.name || ($t('vform.step') + ' ' + step.step) }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="editorMode && (!steps || steps.length === 0)" class="step-nav-hint">
        {{ $t('vform.noStepsFound') }}
      </div>
    </div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import EditorOverlay from "@/components/vForm/viewer/EditorOverlay.vue";

export default {
  name: "STEP_NAVIGATION",
  components: { EditorOverlay },
  mixins: [ElementMixin],
  props: {
    steps: { type: Array, default: () => [] },
    stepUuid: { type: String, default: null },
  },
  computed: {
    sortedSteps() {
      return [...(this.steps || [])].sort((a, b) => (a.step || 0) - (b.step || 0));
    },
    resolvedButtonColor() {
      return this.config.buttonColor || '#ffffff';
    },
    resolvedButtonBackgroundColor() {
      return this.config.buttonBackgroundColor || '#444444';
    },
    resolvedActiveColor() {
      return this.config.activeColor || '#ffffff';
    },
    resolvedActiveBackgroundColor() {
      return this.config.activeBackgroundColor || '#0066cc';
    },
  },
  methods: {
    getButtonStyle(uuid) {
      const isActive = uuid === this.stepUuid;
      return {
        backgroundColor: isActive ? this.resolvedActiveBackgroundColor : this.resolvedButtonBackgroundColor,
        color: isActive ? this.resolvedActiveColor : this.resolvedButtonColor,
        borderColor: isActive ? this.resolvedActiveBackgroundColor : this.resolvedButtonBackgroundColor,
        width: this.config.alignment === 'justify' ? '100%' : '',
      };
    },
    navigate(uuid) {
      if (!this.editorMode && !this.disabled) {
        this.$emit('goToStep', uuid);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.step-nav-wrapper {
  width: 100%;
}

.step-nav-bar-padding {
  padding: 4px 0;
}

.step-nav-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.step-nav-hint {
  font-size: 0.8rem;
  opacity: 0.6;
  padding: 4px 0;
}

/* ensure the text inside wraps */
.wrap-break {
  text-wrap: wrap;
  overflow-wrap: anywhere;
}
</style>






